import React, { useState } from 'react';
import { General } from '../../common/constants';
import { toLocalDayKey } from '../../common/dateTimeUtils';
import { Field, Label } from '../Catalyst/fieldset';
import { ClipLoader } from 'react-spinners';
import clsx from 'clsx';
import { standardInputClasses } from './inputStyles';

const DateTime = ({
    name,
    label,
    value,
    type,
    placeholder,
    onChange,
    className,
    minDate,
    maxDate,
    error,
    loading = false,
}) => {

    const [dateTimeValue, setdateTimeValue] = useState(value || '');

    const onDateChange = (e) => {
        const newValue = e.target.value;
        if (onChange) {
            onChange(e, { name, value: newValue });
        }
        setdateTimeValue(newValue);
    }

    React.useEffect(() => {
        setdateTimeValue(value || '');
    }, [value]);

    // Convert min/max dates to the yyyy-MM-dd format HTML5 inputs expect, using the
    // LOCAL calendar date: toISOString would take the UTC date, which lands one day
    // early for viewers east of UTC (e.g. "today" unselectable in a Sydney evening).
    const formatDateForInput = (date) => {
        if (!date) return undefined;
        if (date instanceof Date) {
            return toLocalDayKey(date);
        }
        return date;
    };

    const inputClass = clsx(
        standardInputClasses,
                            'w-full py-2 px-3 text-sm',
        error && 'border-red-500',
        className
    );

    const renderInput = () => {
        if (type === General.DateTimeSettings.Component.DateOnly) {
            return (
                <input
                    type="date"
                    id={name}
                    name={name}
                    value={dateTimeValue}
                    onChange={onDateChange}
                    min={formatDateForInput(minDate)}
                    max={formatDateForInput(maxDate)}
                    placeholder={placeholder}
                    className={inputClass}
                />
            );
        }

        if (type === General.DateTimeSettings.Component.TimeOnly) {
            return (
                <input
                    type="time"
                    id={name}
                    name={name}
                    value={dateTimeValue}
                    onChange={onDateChange}
                    placeholder={placeholder}
                    className={inputClass}
                />
            );
        }

        if (type === General.DateTimeSettings.Component.FullDateTime) {
            return (
                <input
                    type="datetime-local"
                    id={name}
                    name={name}
                    value={dateTimeValue}
                    onChange={onDateChange}
                    min={formatDateForInput(minDate)}
                    max={formatDateForInput(maxDate)}
                    placeholder={placeholder}
                    className={inputClass}
                />
            );
        }

        // Default to date input
        return (
            <input
                type="date"
                id={name}
                name={name}
                value={dateTimeValue}
                onChange={onDateChange}
                placeholder={placeholder}
                className={inputClass}
            />
        );
    };

    return (
        <Field>
            {label && <Label htmlFor={name}>{label}</Label>}
            <div className="relative mt-1">
                {renderInput()}
                {loading && (
                    <div className="absolute right-3 top-1/2 -translate-y-[45%] z-50 pointer-events-none bg-surface">
                        <ClipLoader color="#6366f1" size={18} />
                    </div>
                )}
            </div>
            {error && <p className="text-sm mt-1 text-text-error">{error}</p>}
        </Field>
    );
}

export default DateTime;